import React from "react";

import { Container, Card, Button, Row, Col } from "react-bootstrap";

import FramePopover from "../Modals/FramePopover";

import * as courses from "../../courseKeys";

import DownloadLink from "react-download-link";

export default function Certificate(props) {
  return (
    <div className="App-body">
      <div className="certificate">
        <Container>
          <h2>Certificate</h2>
          <p class="description">
            <a href="https://www.extension.harvard.edu/">
              Harvard Extension School
            </a>{" "}
            offers a{" "}
            <a href="https://www.extension.harvard.edu/academics/graduate-certificates/graduate-certificate-artificial-intelligence">
              Graduate Certificate in Artificial Intelligence
            </a>{" "}
            that requires four courses in different areas.
          </p>
          <Card id={courses.cscie25}>
            <a
              name={courses.cscie25}
              href="https://coursebrowser.dce.harvard.edu/course/computer-vision/"
              target="_blank"
            >
              <h4>CSCI E-25</h4>
            </a>
            <Card.Body>
              <p class="description">
                A fast-paced overview of computer vision, covering image
                formation, feature detection and matching, classical vs machine
                learning-based techniques using convolutional neural networks
                and vision transformers, and a short technical overview of how
                generative networks work.
              </p>
              <Container>
                <Row>
                  <Col>
                    The final project features severe classification errors due
                    to tremendous image data loss during resizing to match
                    incredibly small training images. Thus, the final project is
                    not shared.
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
          <br />
          <Card id={courses.cscie89B}>
            <a
              name={courses.cscie89B}
              href="https://coursebrowser.dce.harvard.edu/course/introduction-to-natural-language-processing/"
              target="_blank"
            >
              <h4>CSCI E-89B Introduction to Natural Language Processing</h4>
            </a>
            <Card.Body>
              <p class="description">
                Overview of techniques for processing and analyzing human
                language using both Python and R. Libraries include NLTK and
                SpaCy alongside machine learning libraries such as TensorFlow
                and scikit-learn.
              </p>
              <Container>
                <Row>
                  <Col>A final project is forthcoming.</Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
          <br />
          <Card id={courses.cscie101}>
            <a
              name={courses.cscie101}
              href="https://coursebrowser.dce.harvard.edu/course/foundations-of-data-science-and-engineering-2/"
              target="_blank"
            >
              <h4>CSCI E-101 Foundations of Data Science and Engineering</h4>
            </a>
            <Card.Body>
              <p class="description">
                A comprehensive technical introduction to data science and
                engineering. There is a treatment of statistical testing methods
                along with an overview of data science libraries in Python. The
                course also covers data presentation and visualization.
              </p>
            </Card.Body>
          </Card>
          <br />
          <Card id={courses.cscie184}>
            <a
              name={courses.cscie184}
              href="https://coursebrowser.dce.harvard.edu/course/data-science-and-artificial-intelligence-ethics-governance-and-laws-2/"
              target="_blank"
            >
              <h4>
                CSCI E-184 Data Science and Artificial Intelligence: Ethics,
                GGovernance, and Laws
              </h4>
            </a>
            <Card.Body>
              <p class="description">
                This is a course for people with a broad-range of backgrounds,
                focusing on ethical and policy issues in AI and data science
                without requiring too much technical background. However, some
                background in relevant technical topics can still be beneficial.
              </p>
              <Container>
                <Row>
                  <Col>
                    <a
                      href="https://github.com/ASMach/CSCI-E184-PSET3"
                      target="_blank"
                    >
                      PSET 3 on GitHub
                    </a>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <a
                      href="https://github.com/ASMach/CSCI-E184-PSET4"
                      target="_blank"
                    >
                      PSET 4 on GitHub
                    </a>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
          <br />
        </Container>
      </div>
    </div>
  );
}
